<template>
  <FlotoDrawer :open="isOpen" :scrolled-content="false" @hide="isOpen = false">
    <template v-slot:trigger>
      <a @click="handleOpen">
        <MBadge :count="count">
          <!-- <MTooltip placement="right">
            <template v-slot:trigger> -->
          <MButton
            id="notification-btn"
            class="text-neutral admin-page-link"
            :aria-label="$t('notifications')"
          >
            <MIcon name="bell" size="lg" />
          </MButton>
          <!-- </template>
            <span>{{ $t('notifications') }}</span>
          </MTooltip> -->
        </MBadge>
      </a>
    </template>

    <template v-slot:title>
      <span class="text-neutral">{{ $t('notifications') }} </span>
    </template>
    <template v-slot:afterTitle>
      <div class="flex justify-end">
        <div class="flex justify-between items-center px-2">
          <div v-if="notificationItems.length">
            <div>
              <a
                class="text-right mb-1 md-text-xs px-1 font-normal"
                @click="markAllAsRead"
              >
                {{ $tc('mark_all_as_read') }}
              </a>
              <span class="mx-1 border-right"></span>
              <a
                class="text-right mb-1 md-text-xs px-1 font-normal"
                @click="clearAllNotification"
              >
                {{ $tc('clear_all') }}
              </a>
            </div>
          </div>
        </div>
        <div class="flex justify-end mr-4">
          <NotificationSetting />
        </div>
      </div>
    </template>
    <MRow class="h-100">
      <MCol class="flex flex-col h-100" style="padding: 0 !important">
        <!-- <div class="mr-2 flex-col flex border-bot">
          <div class="flex justify-end mb-2 mr-3">
            <NotificationSetting />
          </div>
        </div> -->
        <FlotoScrollView>
          <div class="mr-2 flex-col flex">
            <MRow :gutter="0" class="flex-1 text-left">
              <MCol class="flex flex-col">
                <FlotoCrudContainer
                  ref="crudContainer"
                  :fetch-fn="getNotifications"
                  :per-page="20"
                  :scrollable="false"
                  :update-fn="updateNotifications"
                  :delete-fn="deleteNotifications"
                  :paging="false"
                >
                  <template v-slot:item="{ item, edit, update, remove }">
                    <div class="hierarchy-item flex items-center">
                      <div
                        class="notification-item-container flex flex-1 items-center min-w-0 mr-0 with-bg"
                      >
                        <Item
                          :item="item"
                          type="notification"
                          @remove="remove(item)"
                          @markAsRead="markAsRead(item, update)"
                        />
                      </div>
                    </div>
                  </template>
                </FlotoCrudContainer>
              </MCol>
            </MRow>
          </div>
        </FlotoScrollView>
      </MCol>
    </MRow>
    <template v-slot:actions="{ hide }">
      <MButton variant="default" @click="hide">
        {{ $t('close') }}
      </MButton>
    </template>
  </FlotoDrawer>
</template>

<script>
import NotificationSetting from './notification-setting'
import {
  getNotificationsApi,
  removeNotificationsApi,
  markAsReadNotificationsApi,
  markAllAsReadNotificationsApi,
  clearAllNotificationsApi,
} from './notification-support-api'
import Item from './single-item'

export default {
  name: 'NotificationSupport',
  components: {
    NotificationSetting,
    Item,
  },
  props: {
    count: { type: Number, default: 0 },
  },
  data() {
    return {
      isOpen: false,
      notificationItems: [],
    }
  },
  methods: {
    handleOpen() {
      this.isOpen = true
      this.$emit('onUpdateCount')
    },
    getNotifications(pageSize, offset) {
      return getNotificationsApi(pageSize, offset).then((res) => {
        this.notificationItems = res.items
        return res
      })
    },
    deleteNotifications(item) {
      return removeNotificationsApi(item)
    },
    markAsRead(item, updateFn) {
      return updateFn(item)
    },
    updateNotifications(item) {
      return markAsReadNotificationsApi(item)
    },
    markAllAsRead() {
      return markAllAsReadNotificationsApi().then(() => this.refresh())
    },
    clearAllNotification() {
      return clearAllNotificationsApi().then(() => this.refresh())
    },
    refresh() {
      this.$refs.crudContainer.refresh()
    },
  },
}
</script>

<style lang="less" scoped>
.hierarchy-item {
  padding: 0 !important;

  .notification-item-container {
    // z-index: 1;
    min-height: 40px;
    padding: 0.5rem 0.75rem;
    margin-right: 0;
    font-weight: 400;
    border-bottom: 1px solid var(--border-color);
    // background: rgba(238, 242, 246, 0.4);
    // border-radius: 0.25rem;

    &:hover {
      @apply bg-neutral-lightest cursor-pointer;
    }
  }
}
</style>
